import { render } from "./NotificationsDrawer.vue?vue&type=template&id=924a0d54&ts=true"
import script from "./NotificationsDrawer.vue?vue&type=script&lang=ts"
export * from "./NotificationsDrawer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/lib/components/drawers/NotificationsDrawer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "924a0d54"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('924a0d54', __exports__)) {
    api.reload('924a0d54', __exports__)
  }
  
  module.hot.accept("./NotificationsDrawer.vue?vue&type=template&id=924a0d54&ts=true", () => {
    api.rerender('924a0d54', render)
  })

}


export default __exports__